import { Component, OnInit } from '@angular/core';
import {
  AgGridComponentFrameworkComponent
} from "../../../../../shared/components/ag-grid/ag-grid-component-framework/ag-grid-component-framework.component";
import {CellSourceComponent} from "../../../../../shared/components/cell-source/cell-source.component";
import {Serializer} from "../../../../../shared/interfaces/serializer";
import {CellSelectComponent} from "../../../../../shared/components/cell-select/cell-select.component";
import {CellSourcesComponent} from "../../../../../shared/components/cell-sources/cell-sources.component";
import {TranslateService} from "@ngx-translate/core";
import {SelectOption} from "../../../../../shared/interfaces/form";
import {Visibility} from "../../../../../shared/interfaces/settings";
import {AppService} from "../../../../../shared/services/app.service";
import {SettingsService} from "../../../../../shared/services/settings.service";
import {AppState} from "../../../../../shared/store/store";
import {Store} from "@ngrx/store";
import {Observable} from "rxjs";
import {DataSetDimension} from '../../../../../shared/interfaces/dimensions';
import {
  selectDataSetDimensionNormalizedComponentObjects,
  selectDataSetDimensionsLoading
} from '../../../../../shared/store/dataSetDimensions/dataSetDimensions.selectors';
import {updateDataSetDimension} from '../../../../../shared/store/dataSetDimensions/dataSetDimensions.actions';
import {DimensionComponentObject, DimensionComponentObjects} from '../../../../../shared/classes/dimension-component-object';

@Component({
  selector: 'app-dimensions-normalized-table',
  templateUrl: './dimensions-normalized-table.component.html',
  styleUrls: ['./dimensions-normalized-table.component.scss']
})
export class DimensionsNormalizedTableComponent implements OnInit {

  public readonly normalizedColumnDefs: Array<any> = [
    {
      field: 'dimension',
      autoSize: true,
      minWidth: 200,
      sortable: true,
      filter: 'agTextColumnFilter',
      lockPosition: true,
      headerValueGetter: _ => {
        return this._translateS.instant('settings.dimension');
      },
      valueGetter: params => params.data.payload.attributes.name,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component:  CellSourceComponent,
          componentParams: {
            sourceGetter: (row: Serializer<DataSetDimension>) => row
          }
        };
      }
    },
    {
      field: 'visibility',
      minWidth: 200,
      sortable: true,
      filter: true,
      lockPosition: true,
      tooltipComponent: 'customTooltip',
      headerTooltip: this._translateS.instant('settings.visibility_tooltip'),
      headerValueGetter: _ => {
        return this._translateS.instant('settings.visibility');
      },
      valueGetter: params => params.data.payload.attributes.visibility,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component:  CellSelectComponent,
          componentParams: this._getVisibilityParams()
        };
      },
      filterValueGetter: params => this._translateS.instant(`settings.${params.data.attributes.visibility}`)
    },
    {
      field: 'sources',
      autoSize: true,
      minWidth: 200,
      sortable: false,
      filter: false,
      lockPosition: true,
      suppressMenu: true,
      headerValueGetter: _ => {
        return this._translateS.instant('settings.sources');
      },
      valueGetter: params => params.data.payload.attributes.name,
      filterValueGetter: params => params.data.payload.attributes.name,
      cellRendererFramework: AgGridComponentFrameworkComponent,
      cellRendererParams: _ => {
        return {
          component:  CellSourcesComponent,
          componentParams: {}
        };
      }
    }
  ];

  public readonly defaultColDef: any = {
    resizable: true,
    suppressNavigable: true,
    suppressCellSelection: true,
    menuTabs: ['filterMenuTab'],
    filterParams: {
      buttons: ['reset']
    }
  };

  public readonly dimensions$: Observable<DimensionComponentObjects> = this._store.select(selectDataSetDimensionNormalizedComponentObjects);
  public readonly loading$: Observable<boolean> = this._store.select(selectDataSetDimensionsLoading);

  constructor(
    private readonly _translateS: TranslateService,
    private readonly _appS: AppService,
    private readonly _settingsS: SettingsService,
    private readonly _store: Store<AppState>
  ) { }

  ngOnInit(): void {}

  private _getVisibilityParams(): any {
    return {
      options: this._settingsS.visibilities,
      disabled: this._appS.isNotDatasetAdmin,
      defaultValueGetter: (dimension: DimensionComponentObject) => dimension.payload.attributes.visibility,
      textGetter: (visibility: SelectOption<Visibility, string>) => visibility.text,
      valueGetter: (visibility: SelectOption<Visibility, string>) => visibility.key,
      onValueChanges: (row: any, value: any) => this.updateDimension(row, value)
    }
  }

  public updateDimension(dimension: DimensionComponentObject, visibility: Visibility): void {
    this._store.dispatch(updateDataSetDimension( {
      dimension: dimension.payload as Serializer<DataSetDimension>,
      update: {
        visibility: visibility
      }
    }));
  }

}
